import { popconfirm } from "./utils/popconfirm";
import createElement from "./utils/createElement";

/**
 * @param {Editor} editor
 */

const languages = [
  "English",
  "Korean",
  "Chineese",
  "Japanese",
  "Spanish",
  "Russian",
  "French",
  "Portuguese",
  "German",
  "Italian",
  "Dutch",
  "Indonesian",
  "Filipino",
  "Polish",
];

const makeShorterIcon = `
    <svg width="16" height="16" class="dropdown-item-icon" fill="#878787" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg">
        <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
        <path d="M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 480c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H320z"></path>
    </svg>
`;

const makeLongerIcon = `
    <svg width="16" height="16" class="dropdown-item-icon" fill="#878787" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg">
        <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
        <path d="M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32z"></path>
    </svg>
`;

const fixSpellingIcon = `
    <svg width="16" height="16" class="dropdown-item-icon" fill="#878787" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg">
        <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
        <path d="M112 0C99.1 0 87.4 7.8 82.5 19.7l-66.7 160-13.3 32c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L66.7 224h90.7l5.1 12.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-13.3-32-66.7-160C136.6 7.8 124.9 0 112 0zm18.7 160H93.3L112 115.2 130.7 160zM256 32v96 96c0 17.7 14.3 32 32 32h80c44.2 0 80-35.8 80-80c0-23.1-9.8-43.8-25.4-58.4c6-11.2 9.4-24 9.4-37.6c0-44.2-35.8-80-80-80H288c-17.7 0-32 14.3-32 32zm96 64H320V64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-32 64h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H320V160zM566.6 310.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L352 434.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l192-192z"></path>
    </svg>
`;

const improveWritingIcon = `
    <svg width="16" height="16" class="dropdown-item-icon" fill="#878787" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg">
        <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
        <path d="M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z"></path>
    </svg>
`;

const simplifyLanguageIcon = `
    <svg width="16" height="16" class="dropdown-item-icon" fill="#878787" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
        <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
        <path d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"></path>
    </svg>
`;

const replaceSelectionIcon = `
    <svg width="16" height="16" class="dropdown-item-icon" fill="#878787" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
        <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
        <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"></path>
    </svg>
`;

const discardIcon = `
    <svg width="16" height="16" class="dropdown-item-icon" fill="#878787" viewBox="0 0 384 512" xmlns="http://www.w3.org/2000/svg">
        <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
        <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"></path>
    </svg>
`;

const tryAgainIcon = `
    <svg width="16" height="16" class="dropdown-item-icon" fill="#878787" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
        <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
        <path d="M386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H464c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0s-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3s163.8-62.5 226.3 0L386.3 160z"></path>
    </svg>
`;

const insertBelowIcon = `
    <svg width="16" height="16" class="dropdown-item-icon" fill="#878787" viewBox="0 0 384 512" xmlns="http://www.w3.org/2000/svg">
        <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
        <path d="M32 64C14.3 64 0 49.7 0 32S14.3 0 32 0l96 0c53 0 96 43 96 96l0 306.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 402.7 160 96c0-17.7-14.3-32-32-32L32 64z"></path>
    </svg>
`;

const continueWriting = `
    <svg width="16" height="16" class="dropdown-item-icon" fill="#878787" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
        <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
        <path d="M373.5 27.1C388.5 9.9 410.2 0 433 0c43.6 0 79 35.4 79 79c0 22.8-9.9 44.6-27.1 59.6L277.7 319l-10.3-10.3-64-64L193 234.3 373.5 27.1zM170.3 256.9l10.4 10.4 64 64 10.4 10.4-19.2 83.4c-3.9 17.1-16.9 30.7-33.8 35.4L24.4 510.3l95.4-95.4c2.6 .7 5.4 1.1 8.3 1.1c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32c0 2.9 .4 5.6 1.1 8.3L1.7 487.6 51.5 310c4.7-16.9 18.3-29.9 35.4-33.8l83.4-19.2z"></path>
    </svg>
`;

const changeToneIcon = `
    <svg width="16" height="16" class="dropdown-item-icon" fill="#878787" viewBox="0 0 384 512" xmlns="http://www.w3.org/2000/svg">
        <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
        <path d="M96 96V256c0 53 43 96 96 96s96-43 96-96H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V192H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V128H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c0-53-43-96-96-96S96 43 96 96zM320 240v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V430.4c85.8-11.7 152-85.3 152-174.4V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v24z"></path>
    </svg>
`;

const translateIcon = `
<svg class='dropdown-item-icon' style="width:16px; height:16px; fill:#878787;"  viewBox="0 0 640 512" xmlns="http://www.w3.org/2000/svg">
  <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
  <path d="M0 128C0 92.7 28.7 64 64 64H256h48 16H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H320 304 256 64c-35.3 0-64-28.7-64-64V128zm320 0V384H576V128H320zM178.3 175.9c-3.2-7.2-10.4-11.9-18.3-11.9s-15.1 4.7-18.3 11.9l-64 144c-4.5 10.1 .1 21.9 10.2 26.4s21.9-.1 26.4-10.2l8.9-20.1h73.6l8.9 20.1c4.5 10.1 16.3 14.6 26.4 10.2s14.6-16.3 10.2-26.4l-64-144zM160 233.2L179 276H141l19-42.8zM448 164c11 0 20 9 20 20v4h44 16c11 0 20 9 20 20s-9 20-20 20h-2l-1.6 4.5c-8.9 24.4-22.4 46.6-39.6 65.4c.9 .6 1.8 1.1 2.7 1.6l18.9 11.3c9.5 5.7 12.5 18 6.9 27.4s-18 12.5-27.4 6.9l-18.9-11.3c-4.5-2.7-8.8-5.5-13.1-8.5c-10.6 7.5-21.9 14-34 19.4l-3.6 1.6c-10.1 4.5-21.9-.1-26.4-10.2s.1-21.9 10.2-26.4l3.6-1.6c6.4-2.9 12.6-6.1 18.5-9.8l-12.2-12.2c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l14.6 14.6 .5 .5c12.4-13.1 22.5-28.3 29.8-45H448 376c-11 0-20-9-20-20s9-20 20-20h52v-4c0-11 9-20 20-20z"></path>
</svg>`;

const summarizeIcon = `
<svg class='dropdown-item-icon' style="width:16px; height:16px; fill:#878787;"  viewBox="0 0 640 512" xmlns="http://www.w3.org/2000/svg">
  <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
  <path d="M9.4 9.4C21.9-3.1 42.1-3.1 54.6 9.4L160 114.7V96c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 4.3-.9 8.5-2.4 12.2c-1.6 3.7-3.8 7.3-6.9 10.3l-.1 .1c-3.1 3-6.6 5.3-10.3 6.9c-3.8 1.6-7.9 2.4-12.2 2.4H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h18.7L9.4 54.6C-3.1 42.1-3.1 21.9 9.4 9.4zM256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM114.7 352H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h96 0l.1 0c8.8 0 16.7 3.6 22.5 9.3l.1 .1c3 3.1 5.3 6.6 6.9 10.3c1.6 3.8 2.4 7.9 2.4 12.2v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V397.3L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L114.7 352zM416 96c0-17.7 14.3-32 32-32s32 14.3 32 32v18.7L585.4 9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 160H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H448c-8.8 0-16.8-3.6-22.6-9.3l-.1-.1c-3-3.1-5.3-6.6-6.9-10.3s-2.4-7.8-2.4-12.2l0-.1v0V96zM525.3 352L630.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 397.3V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V320v0c0 0 0-.1 0-.1c0-4.3 .9-8.4 2.4-12.2c1.6-3.8 3.9-7.3 6.9-10.4c5.8-5.8 13.7-9.3 22.5-9.4c0 0 .1 0 .1 0h0 96c17.7 0 32 14.3 32 32s-14.3 32-32 32H525.3z"></path>
</svg>
`;

const findActionItemsIcon = `
<svg class='dropdown-item-icon' style="width:16px; height:16px; fill:#878787;"  viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
  <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
  <path d="M64 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM64 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48-208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"></path>
</svg>
`;

const explainIcon = `
<svg class='dropdown-item-icon' style="width:16px; height:16px; fill:#878787;"  viewBox="0 0 320 512" xmlns="http://www.w3.org/2000/svg">
  <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
  <path d="M80 160c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64v3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74V320c0 17.7 14.3 32 32 32s32-14.3 32-32v-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7V160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"></path>
</svg>
`;

const moreIcon = `
<svg class='dropdown-item-icon' style="width:16px; height:16px; fill:#878787;"  viewBox="0 0 128 512" xmlns="http://www.w3.org/2000/svg">
  <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
  <path d="M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"></path>
</svg>
`;

const expandRightIcon = `
<svg class='dropdown-item-icon' style="width:12px; height:12px; fill:#878787; margin-left: auto;"  viewBox="0 0 320 512" xmlns="http://www.w3.org/2000/svg">
  <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
  <path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"></path>
</svg>
`;

const trashIcon = `
<svg style="width:30px; height:30px; fill:#8e8e8e;"  viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
  <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
  <path d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"></path>
</svg>
`;

const predefinedActionsIcons = {
  "improve-writing": improveWritingIcon,
  "fix-spelling": fixSpellingIcon,
  "make-shorter": makeShorterIcon,
  "make-longer": makeLongerIcon,
  "simplify-language": simplifyLanguageIcon,
  "continue-writing": continueWriting,
  summarize: summarizeIcon,
  translate: translateIcon,
  "find-action-items": findActionItemsIcon,
  "explain-this": explainIcon,
};

const responseActionsIcons = {
  "replace-selection": replaceSelectionIcon,
  discard: discardIcon,
  "try-again": tryAgainIcon,
  "insert-below": insertBelowIcon,
};

const csrfToken = document
  .querySelector("meta[name=token]")
  .getAttribute("content");

let reader = null;
let lastAction = "";
let lastTone = "";
let lastQuery = "";
let isAiThinking = false;
const dropdownEvents = {};
const togglerEvents = {};

function calculateDropdownPosition(
  dropdown,
  tmceEditorIframe,
  editor,
  currentLine
) {
  const editorRect = tmceEditorIframe.getBoundingClientRect();
  const currentLineRect = currentLine.getBoundingClientRect();
  const selectionRect = editor.selection.getBoundingClientRect();
  const isNarrowScreen = window.innerWidth <= 420;

  let offsetTop = 22;
  let offsetLeft = 0;

  if (editor) {
    offsetTop += selectionRect.top + selectionRect.height;
    offsetLeft += isNarrowScreen ? 0 : currentLineRect.left;
  }

  dropdown.style.top = `${editorRect.top + offsetTop - 12}px`;
  dropdown.style.left = `${editorRect.left + offsetLeft}px`;
  dropdown.style.width = `${currentLineRect.width}px`;
}

function calculateTogglerPosition(
  toggler,
  tmceEditorIframe,
  editor,
) {
  const editorRect = tmceEditorIframe.getBoundingClientRect();
  const selectionRect = editor.selection.getBoundingClientRect();
  const isNarrowScreen = window.innerWidth <= 420;
  const togglerWidth = 79;


  let offsetTop = -33;
  let offsetLeft = 0;

  if (editor) {
    offsetTop += selectionRect.top;
    offsetLeft += isNarrowScreen ? 0 : selectionRect.left - (togglerWidth / 2);
  }
  

  toggler.style.top = `${editorRect.top + offsetTop - 12}px`;
  toggler.style.left = `${editorRect.left + offsetLeft}px`;
}

const stopStreamResponse = async (reader) => {
  if (reader) {
    await reader.cancel();
    reader = null;
  }
};

function hideElement(id) {
  const element = document.getElementById(id);
  if (!element) return;
  const animationDuration = 120;

  if (element.classList.contains("anim")) {
    element.classList.remove("fadeIn");
    element.classList.add("fadeOut");
    setTimeout(() => {
      element.classList.add("d-none");
    }, animationDuration);
  } else {
    element.classList.add("d-none");
  }
}

function removeElement(id) {
  const element = document.getElementById(id);

  if (element.classList.contains("anim")) {
    element.classList.remove("fadeIn");
    element.classList.add("fadeOut");
    element.addEventListener("animationend", () => {
      element.remove();
    });
  } else {
    element.remove();
  }
}

function removeDropdownEvents() {
  window.removeEventListener("resize", dropdownEvents.onScrollOrResize);
  document
    .querySelector("#html-editor_ifr")
    .contentWindow.removeEventListener("scroll", dropdownEvents.onScrollOrResize);
  document.removeEventListener("keydown", dropdownEvents.onDocumentKeydown);
  document
    .querySelector("#html-editor_ifr")
    .contentWindow.removeEventListener("keydown", dropdownEvents.onIfrKeydown);
  document.removeEventListener("mousedown", dropdownEvents.onMousedown);
  document
    .querySelector("#html-editor_ifr")
    .contentWindow.removeEventListener("mousedown", dropdownEvents.onMousedown);
}

function removeTogglerEvents() {
  window.removeEventListener("resize", togglerEvents.onScrollOrResize);
  document
    .querySelector("#html-editor_ifr")
    .contentWindow.removeEventListener("scroll", togglerEvents.onScrollOrResize);
  document.removeEventListener("mousedown", togglerEvents.onMousedown);
  document
    .querySelector("#html-editor_ifr")
    .contentWindow.removeEventListener("mousedown", togglerEvents.onMousedown);
  document
    .querySelector("#html-editor_ifr")
    .contentWindow.removeEventListener("keydown", togglerEvents.onIfrKeydown);
}

function showElement(id) {
  const element = document.getElementById(id);

  if (!element) return;

  element.classList.remove("d-none");
  if (element.classList.contains("anim")) {
    element.classList.remove("fadeOut");
    element.classList.add("fadeIn");
  }
}

const askAi = async (action, editor, tone = "") => {
  isAiThinking = true;
  const input = document.getElementById("edit-ai-input");
  const query = input ? input.value : "";

  if (action === "edit-ai-basic") {
    lastQuery = query;
  } else {
    lastQuery = "";
  }

  lastAction = action;
  lastTone = tone;

  input.value = "";
  input.setAttribute("disabled", "disabled");
  input.placeholder = "AI is writing...";

  showElement("edit-ai-loader");
  showElement("edit-ai-input-actions-container");
  hideElement("ai-actions-dropdown");
  hideElement("ai-response-actions-dropdown");

  const isTranslation = action.includes("translate");

  const response = await fetch(
    `${window.location.origin}/ai/edit/${
      isTranslation ? action.split("-")[0] : action
    }`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-TOKEN": csrfToken,
      },
      body: JSON.stringify({
        query: isTranslation ? action.split("-")[1] : query || lastQuery,
        context: editor.selection.getContent(),
        action: isTranslation ? action.split("-")[0] : action,
        tone,
      }),
    }
  );

  const responseContainer = document.getElementById("ai-response-container");

  if (response.status !== 200) {
    try {
      const resJson = await response.json();
      responseContainer.innerHTML = resJson.error;
    }
    catch (e) {
      responseContainer.innerHTML = 'An error occurred. Please try again. Or contact CogniVis administrator.';
    }

    showElement("ai-response-container");
    showElement("ai-response-actions-dropdown");

    input.placeholder = "Ask AI...";
    input.removeAttribute("disabled");
    input.value = query;

    hideElement("edit-ai-loader");
    hideElement("edit-ai-input-actions-container");
    return;
  }

  reader = response.body.getReader();
  const decoder = new TextDecoder();
  const parser = new DOMParser();

  showElement("ai-response-container");

  let res = "";

  // eslint-disable-next-line no-constant-condition
  while (true) {
    // eslint-disable-next-line no-await-in-loop
    const { done, value } = await reader.read();

    if (done) {
      reader = null;
      break;
    } // Exit the loop if the stream is finished

    // Decode and append the chunk of data to the container
    res += decoder.decode(value);

    responseContainer.innerHTML = parser.parseFromString(
      res,
      "text/html"
    ).body.innerHTML;
  }

  showElement("ai-response-actions-dropdown");

  input.placeholder = "Ask AI...";
  input.removeAttribute("disabled");
  input.value = query;

  hideElement("edit-ai-loader");
  hideElement("edit-ai-input-actions-container");
};

function createAiActionsDropdown(editor) {
  const input = document.getElementById("edit-ai-input");

  // Create AI actions container
  const aiActionsContainer = createElement(
    "div",
    "edit-ai-input-actions-container",
    ["edit-ai-actions-container", "anim", "d-none"]
  );
  const tryAgainBtn = createElement(
    "div",
    "try-again",
    ["edit-ai-input-action-button"],
    {},
    "Try again"
  );
  const stopBtn = createElement(
    "div",
    "stop-action",
    ["edit-ai-input-action-button"],
    {},
    "Stop"
  );
  const tryAgainShortcutText = createElement(
    "span",
    "",
    ["edit-ai-input-action-shortcut"],
    {},
    "R"
  );
  const stopShortcutText = createElement(
    "span",
    "",
    ["edit-ai-input-action-shortcut"],
    {},
    "Esc"
  );

  tryAgainBtn.role = "button";
  stopBtn.role = "button";

  tryAgainBtn.appendChild(tryAgainShortcutText);
  stopBtn.appendChild(stopShortcutText);
  aiActionsContainer.appendChild(tryAgainBtn);
  aiActionsContainer.appendChild(stopBtn);

  const tryAgainCallback = () => {
    const responseContainer = document.querySelector(".ai-response-container");
    const isAiWriting =
      responseContainer && !responseContainer.classList.contains("d-none");
    if (!isAiWriting) {
      return;
    }

    stopStreamResponse(reader);
    input.value = lastQuery;
    askAi(lastAction, editor, lastTone);

    setTimeout(() => {
      input.setAttribute("disabled", "disabled");
      input.placeholder = "AI is writing...";
      input.value = "";
      showElement("edit-ai-loader");
    }, 30);
  };

  tryAgainBtn.addEventListener("click", tryAgainCallback);

  stopBtn.addEventListener("click", () => {
    stopStreamResponse(reader);
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "r" && reader) {
      tryAgainCallback();
    } else if (e.key === "Escape" && reader) {
      isAiThinking = false;
      stopStreamResponse(reader);
    }
  });

  return aiActionsContainer;
}

function createResponseActionDropdown(editor) {
  const aiResponseActionDropdown = createElement(
    "div",
    "ai-response-actions-dropdown",
    ["ai-actions-dropdown", "anim", "d-none"]
  );
  ["Replace selection", "Insert below", "Try again", "Discard"].forEach(
    (action) => {
      const id = action.toLowerCase().replace(" ", "-");
      const aiResponseActionElement = createElement(
        "div",
        `${id}`,
        ["edit-ai-dropdown-item"],
        {},
        action
      );

      aiResponseActionElement.addEventListener("click", () => {
        const responseContainer = document.getElementById(
          "ai-response-container"
        );
        const response = responseContainer.innerHTML.trim();
        isAiThinking = false;

        if (id === "replace-selection") {
          const isList = response.includes("<ul>") || response.includes("<ol>");
          editor.selection.setContent(isList ? response : response.replace(/\n/g, "<br />"));
          removeElement("edit-ai-dropdown");
          removeDropdownEvents();
          editor.undoManager.add();
        } else if (id === "insert-below") {
          const newText = ` ${editor.selection.getContent()} <p>${response.replace(
            /\n/g,
            "<br />"
          )}</p>`;
          editor.selection.setContent(newText);
          removeElement("edit-ai-dropdown");
          removeDropdownEvents();
          editor.undoManager.add();
        } else if (id === "try-again") {
          hideElement("ai-response-actions-dropdown");
          askAi(lastAction, editor, lastTone);
        } else if (id === "discard") {
          removeElement("edit-ai-dropdown");
          removeDropdownEvents();
        }
      });

      aiResponseActionElement.insertAdjacentHTML(
        "afterbegin",
        responseActionsIcons[id]
      );
      aiResponseActionDropdown.appendChild(aiResponseActionElement);
    }
  );

  return aiResponseActionDropdown;
}

function createChangeToneDropdownItem(editor) {
  const changeToneDropdownItem = createElement(
    "div",
    "change-tone",
    ["edit-ai-dropdown-item", "position-relative"],
    {},
    "Change tone"
  );
  changeToneDropdownItem.insertAdjacentHTML("afterbegin", changeToneIcon);
  changeToneDropdownItem.insertAdjacentHTML("beforeend", expandRightIcon);

  const aiChangeToneDropdown = createElement("div", "ai-change-tone-dropdown", [
    "ai-actions-dropdown",
    "position-absolute",
    "nested-dropdown",
    "anim",
    "fadeIn",
  ]);

  [
    "Professional",
    "Casual",
    "Straightforward",
    "Confident",
    "Friendly",
  ].forEach((tone) => {
    const id = tone.toLowerCase().replace(" ", "-");
    const aiChangeToneItem = createElement(
      "div",
      `${id}`,
      ["edit-ai-dropdown-item"],
      {},
      tone
    );

    aiChangeToneItem.addEventListener("click", () => {
      askAi("change-tone", editor, id);
      hideElement("ai-actions-dropdown");
    });
    aiChangeToneDropdown.appendChild(aiChangeToneItem);
    changeToneDropdownItem.appendChild(aiChangeToneDropdown);
  });

  return changeToneDropdownItem;
}

function createMoreDropdownItem(editor) {
  const moreDropdownItem = createElement(
    "div",
    "more",
    ["edit-ai-dropdown-item", "position-relative"],
    {},
    "More"
  );
  moreDropdownItem.insertAdjacentHTML("afterbegin", moreIcon);
  moreDropdownItem.insertAdjacentHTML("beforeend", expandRightIcon);

  const aiMoreDropdown = createElement("div", "ai-more-dropdown", [
    "ai-actions-dropdown",
    "position-absolute",
    "nested-dropdown",
    "anim",
    "fadeIn",
  ]);

  const additionalActions = [
    {
      id: "rephrase",
      label: "Rephrase",
    },
    {
      id: "essence",
      label: "Essence",
    },
    {
      id: "reformat",
      label: "Reformat",
    },
    {
      id: "key-points",
      label: "Key points",
    },
    {
      id: "tone-down",
      label: "Tone down",
    },
    {
      id: "similar",
      label: "Similar",
    },
  ];

  additionalActions.forEach((action) => {
    const actionItem = createElement(
      "div",
      action.id,
      ["edit-ai-dropdown-item"],
      {},
      action.label
    );
    actionItem.addEventListener("click", () => {
      askAi(action.id, editor);
      hideElement("ai-actions-dropdown");
    });
    aiMoreDropdown.appendChild(actionItem);
  });

  moreDropdownItem.appendChild(aiMoreDropdown);
  return moreDropdownItem;
}

function createPredefinedActionsDropdown(editor) {
  const aiPredefinedActionsDropdown = createElement(
    "div",
    "ai-actions-dropdown",
    ["ai-actions-dropdown", "anim", "fadeIn"]
  );

  [
    "Edit or review selection",
    "Improve Writing",
    "Fix Spelling",
    "Make shorter",
    "Make longer",
    "Simplify language",
    "Continue writing",
    "Generate from selection",
    "Summarize",
    "Translate",
    "Find action items",
    "Explain this",
  ].forEach((action) => {
    const id = action.toLowerCase().replaceAll(" ", "-");
    if (
      action === "Edit or review selection" ||
      action === "Generate from selection"
    ) {
      const dropdownLabel = createElement(
        "div",
        "edit-ai-dropdown-label",
        ["edit-ai-dropdown-label"],
        {},
        action
      );
      aiPredefinedActionsDropdown.appendChild(dropdownLabel);
      return;
    }

    if (action === "Translate") {
      const dropdownItem = createElement(
        "div",
        "translate",
        ["edit-ai-dropdown-item", "position-relative"],
        {}
      );

      const languagesDropdown = createElement(
        "div",
        "edit-ai-languages-dropdown",
        ["ai-actions-dropdown", "position-absolute", "nested-dropdown"]
      );
      dropdownItem.insertAdjacentHTML("afterbegin", translateIcon);
      dropdownItem.insertAdjacentHTML("beforeend", "<span>Translate</span>");
      dropdownItem.insertAdjacentHTML("beforeend", expandRightIcon);
      languages.forEach((language) => {
        const langDropdownItem = createElement(
          "div",
          `${id}`,
          ["edit-ai-dropdown-item"],
          {},
          language
        );

        langDropdownItem.addEventListener("click", async () => {
          askAi(`translate-${language}`, editor);
          hideElement("ai-actions-dropdown");
        });
        languagesDropdown.appendChild(langDropdownItem);
      });
      dropdownItem.appendChild(languagesDropdown);
      aiPredefinedActionsDropdown.appendChild(dropdownItem);
      return;
    }

    const aiPredefinedActionElement = createElement(
      "div",
      `${id}`,
      ["edit-ai-dropdown-item"],
      {},
      action
    );

    aiPredefinedActionElement.addEventListener("click", () => {
      askAi(id, editor);
      hideElement("ai-actions-dropdown");
    });

    aiPredefinedActionElement.insertAdjacentHTML(
      "afterbegin",
      predefinedActionsIcons[id]
    );
    aiPredefinedActionsDropdown.appendChild(aiPredefinedActionElement);
  });

  const changeToneDropdownItem = createChangeToneDropdownItem(editor);

  aiPredefinedActionsDropdown.appendChild(changeToneDropdownItem);

  const moreDropdownLabel = createElement(
    "div",
    "",
    ["edit-ai-more-dropdown-label"],
    {}
  );
  aiPredefinedActionsDropdown.appendChild(moreDropdownLabel); // Append the label here

  // Create and append the moreDropdownItem
  const moreDropdownItem = createMoreDropdownItem(editor);
  aiPredefinedActionsDropdown.appendChild(moreDropdownItem);

  return aiPredefinedActionsDropdown;
}

function createInputForm(editor) {
  const form = document.createElement("form");

  const inputWrapper = createElement("div", "edit-ai-input-wrapper", [
    "edit-ai-input-wrapper",
  ]);
  const loader = createElement("span", "edit-ai-loader", [
    "edit-ai-loader",
    "d-none",
  ]);
  const input = createElement("input", "edit-ai-input", ["edit-ai-input"]);
  const focusOrCloseInfo = createElement(
    "span",
    "close-info",
    ["edit-ai-close-info", "anim", "fadeIn"],
    {},
    "Press Esc to close"
  );

  input.type = "text";
  input.placeholder = "Ask AI...";

  inputWrapper.appendChild(loader);
  inputWrapper.appendChild(input);
  inputWrapper.appendChild(focusOrCloseInfo);
  form.appendChild(inputWrapper);

  input.addEventListener("focus", () => {
    showElement("close-info");
  });
  input.addEventListener("blur", () => {
    hideElement("close-info");
  });
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    askAi("edit-ai-basic", editor);
  });

  return form;
}

function createEditAiToggler(editor) {
  const currentLine = editor.selection.getNode();
  const tmceEditorIframe = editor.getContainer().querySelector("iframe");
  
  const editAiToggler = createElement(
    "button",
    "edit-ai-toggler",
    ["edit-ai-toggler", "anim", "fadeIn"],
    {},
    "Use AI"
  );

  editAiToggler.insertAdjacentHTML("afterbegin", improveWritingIcon);

  calculateTogglerPosition(
    editAiToggler,
    tmceEditorIframe,
    editor,
  );
  document.body.appendChild(editAiToggler);

  editAiToggler.addEventListener("click", () => {
    createEditAiDropdown(editor);

    removeElement("edit-ai-toggler");
    removeTogglerEvents();
  });

  togglerEvents.onIfrKeydown = () => {
    removeElement("edit-ai-toggler");
    removeTogglerEvents();
    editor.focus();
  };
  document
    .querySelector("#html-editor_ifr")
    .contentWindow.addEventListener("keydown", togglerEvents.onIfrKeydown);

  togglerEvents.onScrollOrResize = () => {
    calculateTogglerPosition(
      editAiToggler,
      tmceEditorIframe,
      editor,
      currentLine
    );
  };
  window.addEventListener("resize", togglerEvents.onScrollOrResize);
  document
    .querySelector("#html-editor_ifr")
    .contentWindow.addEventListener("scroll", togglerEvents.onScrollOrResize);

  togglerEvents.onMousedown = async (e) => {
    if (editAiToggler && !editAiToggler.contains(e.target)) {
      e.preventDefault();

      removeElement("edit-ai-toggler");
      removeTogglerEvents();
    }
  };
  document.addEventListener("mousedown", togglerEvents.onMousedown);
  document
    .querySelector("#html-editor_ifr")
    .contentWindow.addEventListener("mousedown", togglerEvents.onMousedown);
}

function createEditAiDropdown(editor) {
  const currentLine = editor.selection.getNode();
  const tmceEditorIframe = editor.getContainer().querySelector("iframe");

  const askAiDropdown = createElement("div", "edit-ai-dropdown", [
    "edit-ai-dropdown",
    "anim",
    "fadeIn",
  ]);
  calculateDropdownPosition(
    askAiDropdown,
    tmceEditorIframe,
    editor,
    currentLine
  );
  document.body.appendChild(askAiDropdown);

  const inputForm = createInputForm(editor);
  askAiDropdown.appendChild(inputForm);

  const actionsDropdownContainer = createElement(
    "div",
    "ai-actions-dropdown-container"
  );
  const responseContainer = createElement("div", "ai-response-container", [
    "ai-response-container",
    "d-none",
  ]);
  actionsDropdownContainer.appendChild(responseContainer);

  const aiResponseActionDropdown = createResponseActionDropdown(editor);
  actionsDropdownContainer.appendChild(aiResponseActionDropdown);
  askAiDropdown.appendChild(actionsDropdownContainer);

  const aiPredefinedActionsDropdown = createPredefinedActionsDropdown(editor);
  actionsDropdownContainer.appendChild(aiPredefinedActionsDropdown);

  const inputWrapper = document.getElementById("edit-ai-input-wrapper");
  const aiActionsContainer = createAiActionsDropdown(editor);
  inputWrapper.appendChild(aiActionsContainer);

  const input = document.getElementById("edit-ai-input");
  input.focus();
  
  dropdownEvents.onScrollOrResize = () => {
    calculateDropdownPosition(
      askAiDropdown,
      tmceEditorIframe,
      editor,
      currentLine
    );
  };
  window.addEventListener("resize", dropdownEvents.onScrollOrResize);
  document
    .querySelector("#html-editor_ifr")
    .contentWindow.addEventListener("scroll", dropdownEvents.onScrollOrResize);

  dropdownEvents.onDocumentKeydown = (e) => {
    if (e.key === "Escape") {
      removeElement("edit-ai-dropdown");
      removeDropdownEvents();
      editor.focus();
      isAiThinking = false;
    }
  };
  document.addEventListener("keydown", dropdownEvents.onDocumentKeydown);

  dropdownEvents.onIfrKeydown = (e) => {
      if (e.ctrlKey && e.altKey) {
        return;
      }
      removeElement("edit-ai-dropdown");
      removeDropdownEvents();
      editor.focus();
  };
  document
    .querySelector("#html-editor_ifr")
    .contentWindow.addEventListener("keydown", dropdownEvents.onIfrKeydown);

  dropdownEvents.onMousedown = async (e) => {
    if (askAiDropdown && !askAiDropdown.contains(e.target)) {
      e.preventDefault();
      const discardConfirm = isAiThinking ? await popconfirm() : true;
      if (!discardConfirm) return;

      removeElement("edit-ai-dropdown");
      removeDropdownEvents();
      editor.focus();
    }
  };
  document.addEventListener("mousedown", dropdownEvents.onMousedown);
  document
    .querySelector("#html-editor_ifr")
    .contentWindow.addEventListener("mousedown", dropdownEvents.onMousedown);
}

function register(editor) {
  editor.on("mousedown", () => {
    document
      .querySelector("#html-editor_ifr")
      .contentWindow.getSelection()
      .empty();
  });

  editor.on("mouseup", () => {
    const selection = editor.selection.getContent();

    if (selection.trim() === "") return;

    createEditAiToggler(editor);
  });

  editor.on("keydown", (event) => {
    const selection = editor.selection.getContent();

    if (selection.trim() === "") return;

    if (event.ctrlKey && event.altKey && event.key === "r") {
      createEditAiDropdown(editor);
      askAi("improve-writing", editor);
    }
    if (event.ctrlKey && event.altKey && event.key === "f") {
      createEditAiDropdown(editor);
      askAi("fix-spelling", editor);
    }
    if (event.ctrlKey && event.altKey && event.key === "d") {
      createEditAiDropdown(editor);
      askAi("make-shorter", editor);
    }
    if (event.ctrlKey && event.altKey && event.key === "q") {
      createEditAiDropdown(editor);
      askAi("make-longer", editor);
    }
    if (event.ctrlKey && event.altKey && event.key === "w") {
      createEditAiDropdown(editor);
      askAi("simplify-language", editor);
    }
    if (event.ctrlKey && event.altKey && event.key === "v") {
      createEditAiDropdown(editor);
      askAi("continue-writing", editor);
    }
  });
}

/**
 * @return {register}
 */
export function getPlugin() {
  return register;
}

export {
  askAi,
  createAiActionsDropdown,
  createElement,
  stopStreamResponse,
  showElement,
  hideElement,
};
